module.exports = __webpack_public_path__ + "static/media/o18.72f698d8.png";